import { Box, Grid, IconButton, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import BlueCancelButton from "../../components/customButtons/BlueCancelButton";
import PrimarySmallBlueButton from "../../components/customButtons/PrimarySmallBlueButton";
import CustomTextField from "../../components/customFields/CustomTextField";
import {
  cancelDemo,
  getCancelAndRescheduleReasons,
} from "../testPrepDashboard/Api/DashboardApi";
import CustomSelectField from "../../components/customFields/CustomSelectField";
import CustomTextFieldSelectNormal from "../../components/customFields/CustomTextFieldSelectNormal";
import ConfimationPopup from "../../components/customPopup/ConfimationPopup";
import ErrorPopup from "../../components/customPopup/ErrorPopup";
import ErrorDialog from "../../components/customPopup/ErrorDialog";

export default function CancelDemoForm({
  handleClose,
  selectedData,
  handleOpenSuccessPopup,
}) {
  const [reason, setReason] = useState("");
  const [reasonData, setreasonData] = useState([]);
  const userId = localStorage.getItem("userId");
  const maxLength = 100;
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");


  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getCancelAndRescheduleReasons(2);

        setreasonData(data?.data);
      } catch (err) {
        console.error("Could not fetch reasons");
      }
    };

    fetchData();
  }, []);

  const handleCancelDemo = async () => {
    if(!reason) {
      setErrorMessage("Please select reason from list before continue")
       handleOpenErrorPopup();
      return;
    }
    try {
      const payload = {
        id: selectedData?.id,
        sp_cancel_reason_id: reason,
        user_id: userId,
      };

      const response = await cancelDemo(payload);
      if (response.status === 200) {
        handleClose();
        handleOpenSuccessPopup();
      } else if ([400, 409, 401, 500].includes(response.status)) {
        setErrorMessage(response?.message);
        handleOpenErrorPopup();
      } else {
        setErrorMessage(response?.message);
        handleOpenErrorPopup();
      }
    } catch (error) {
      setErrorMessage("Internal Server Error");
      handleOpenErrorPopup();
    }
  };

  // error popup

  const handleOpenErrorPopup = () => {
    setOpenErrorPopup(true);
  };

  const handleCloseErrorPopup = () => {
    setOpenErrorPopup(false);
  };

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={2}
        p={1}
      >
        <Grid item xs={12} textAlign="center">
          <IconButton
            sx={{
              width: 81,
              height: 81,
              backgroundColor: "#8A40B51A",
              borderRadius: "50%",
              backdropFilter: "blur(4px)",
              overflow: "visible", // :white_tick: allow image overflow
              position: "relative",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.4)",
              },
            }}
          >
            <Box
              component="img"
              src="/newdashboard/Demo/45fa3ce24c0603ebac6fbecf1de19711fd49ee80.gif"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)", // :white_tick: keep it centered
                pointerEvents: "none", // :white_tick: so click still works on button
              }}
            />
          </IconButton>
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Typography
            fontSize="24px"
            color="#8A40B5"
            sx={{
              fontWeight: 400,
              fontFamily: "Inter",
              lineHeight: "100%",
              fontStyle: "normal",
              letterSpacing: "0%",
            }}
          >
            Thinking of Canceling?
          </Typography>
        </Grid>

        <Grid item xs={12} textAlign="center">
          <Typography
            fontSize="14px"
            color="#444444"
            sx={{
              fontWeight: 400,
              fontFamily: "Inter",

              fontStyle: "normal",
              letterSpacing: "0.1px",
            }}
          >
            If you cancel now, this demo will be removed from your schedule.
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <CustomTextFieldSelectNormal
            fullWidth
            size="medium"
            placeholder="Select a cancellation reason "
            backgroundColor="#F9F9F9"
            options={reasonData}
            onChange={(e)=>setReason(e.target.value)}
            getOptionLabel={(opt) => opt?.name}
            getOptionValue={(opt) => opt?.id}
          />
        </Grid>

        {/* Cancel Button */}
        <Grid
          item
          xs={12}
          container
          gap={2}
          justifyContent="center"
          alignItems="center"
          mt={2}
          mb={2}
        >
          <BlueCancelButton
            buttonTitle="Keep Demo"
            onClick={handleClose}
            width="174px"
          />
          <PrimarySmallBlueButton
            // startIcon={startIcon}
            buttonTitle="Yes , Cancel"
            onClick={handleCancelDemo}
            width="174px"
          />
        </Grid>
      </Grid>

      <ConfimationPopup
        handleClose={handleCloseErrorPopup}
        component={
          <ErrorPopup
            handleClose={handleCloseErrorPopup}
            const
            subText={errorMessage}
            buttonTitle="Continue"
            // startIcon={<ArticleIcon />}
            navigateLink="/test-prep/demos"
          />
        }
        open={openErrorPopup}
        subtitle=""
        maxWidth="xs"
      />
    </>
  );
}
